import {
    STORE_ADD_ITEM,
    STORE_ADD_ITEM_SUCEESS,
    STORE_ADD_ITEM_FAILURE,
    CLEAR_ADD_ITEM,
} from '../actions/actionTypes';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const initialState = {
    addItem :[],

};

const storeAddItemDataReducer = (state = initialState, action) => {
 
    switch (action.type) {
        case STORE_ADD_ITEM:
            return {
                ...state,
                addItem:[...action.payload],

            };
        case STORE_ADD_ITEM_SUCEESS:
            return {
                ...state,
                addItem: [...action.payload],

            };
        case STORE_ADD_ITEM_FAILURE:
            return {
                ...state,
                addItem: [],

            };
        case CLEAR_ADD_ITEM:
            return {
                ...state,
                addItem :[]
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'storeAddItemDataKey',
        storage: storage,
    },
    storeAddItemDataReducer
);
